module.exports = __webpack_public_path__ + "static/media/4.05b01f04.jpg";